export const breadcrumbNameMap = {
   '/site-policies': 'Políticas del Sitio',
   '/dashboard/mutual-world': 'Mundo Mutual',
   '/dashboard/mutual-world/cuestionario': 'Crear cuestionario',
   '/dashboard/mutual-world/response-questionary': 'Responder cuestionario'
}
